import React, { useState, useEffect } from 'react';

import { createAPIEndpoint, windowOpen } from '../api/index'
import { getConfiguration, ENDPOINTS } from '../api/config'
import { withPublicUrl } from '../helper/publicUrl'

import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';
import Plantilla from './plantillas/Plantilla'

import Spinner from './Spinner';
import ErrorModal, { useErrorHandling } from './ErrorModal';
import { ContinuarMasTardeButton } from './ContinuarMasTardeButton';
import { setProgress } from './Progreso';

import { getPaymentSSO, PortalError, isUserFromApp } from '../api/index'

class innerRequisito {
    constructor(requisito) {
        const getRequerido = (r) => { return r.requerido.toLowerCase() === "si" };
        const getCumple = (r) => { return r.cumple.toLowerCase() === "cumple" };
        const getMostrar = (r) => { return r.mostrar.toLowerCase() === "si" };

        this.idrequisito = requisito.idrequisito; 
        this.requerido = getRequerido(requisito);
        this.cumple = getCumple(requisito);
        this.mostrar = getMostrar(requisito);
        this.etiqueta = requisito.etiqueta;
        this.lista = requisito.lista;

        this.estado = "error";
        if (this.cumple) {
            this.estado = "success";
        }
        else {
            if (this.requerido) this.estado = "error";
            if (!this.requerido) this.estado = "warning";
        }

        if (this.requerido && !this.mostrar && !this.cumple) {
            this.mostrar = true;
        }

        this.mensaje = requisito.mensajerequerido;
        //if (this.requerido) this.mensaje = requisito.mensajerequerido;

        this.icono = <span className="plantilla material-symbols-outlined icon requisito">help_outline</span>
        if (this.estado === "success")
            this.icono = <span className="plantilla material-symbols-outlined icon requisito" style={{ color: "var(--green)" }}>check_circle</span>
        if (this.estado === "error")
            this.icono = <span className="plantilla material-symbols-outlined icon requisito" style={{ color: "var(--red)" }}>error</span>
        if (this.estado === "warning")
            this.icono = <span className="plantilla material-symbols-outlined icon requisito" style={{ color: "var(--orange)" }}>schedule</span>

    }
}

function Requisito({ requisito, onBotonPortalPagosClick }) {
    const [showModal, setShowModal] = useState(false);

    const handleRedirectToPortalPagos = () => { onBotonPortalPagosClick() };

    let req = requisito;
    if (!req.mostrar) return null;

    return (<>
        <div className="plantilla container-solid">
            <div className="flex-container">
                <div>{req.icono}</div>
                <div style={{ alignContent: "center" }}>
                    <div className="requisito title"><strong>{req.etiqueta}</strong></div>
                    {!req.cumple &&
                        <div style={{ color: "#ee1b1b" }}>
                            <small dangerouslySetInnerHTML={{ __html: req.mensaje }}></small>
                        </div>
                    }
                </div>
            </div>

            {!req.cumple && req.idrequisito !== "REQPINS" && (
                <Col className="d-grid mt-3" >
                    <Button variant="link" onClick={() => { setShowModal(true) }} style={{
                        alignItems: "center",
                        display: "inline-flex",
                        textDecoration: "none",
                        justifyContent: "center",
                    }}>
                        <span style={{ margin: "10px", textDecoration: "underline" }}>Más información</span>
                        <span className="material-symbols-outlined">launch</span>
                    </Button>

                    <ModalRequisito show={showModal} requisito={req} onClose={() => setShowModal(false)} />
                </Col>
            )}

            {!req.cumple && req.idrequisito === "REQPINS" && (
                //<div className="plantilla container-solid" style={{ padding: "10px", textAlign: "center" }}>
                <Col className="d-grid mt-3" >
                    <Button variant="link" onClick={() => { handleRedirectToPortalPagos() }} style={{
                        alignItems: "center",
                        display: "inline-flex",
                        textDecoration: "none",
                        justifyContent: "center",
                    }}>
                    
                        <span style={{ margin: "10px", textDecoration: "underline" }}>Pagar aqui</span>
                        <span className="material-symbols-outlined">launch</span>
                    </Button>

                    {/*<ModalDialog fullname={req.etiqueta} ciclo={ req.mensaje}  />*/}
                    <ModalRequisito show={showModal} requisito={req} onClose={() => setShowModal(false)} />
                {/*</div>*/}
                </Col>
            )}

        </div>
    </>);
}

const ModalRequisito = ({ show, requisito, onClose }) => {
    const handleClose = () => onClose();

    const ElementoLista = ({ item }) => {
        let etiqueta = item.etiqueta;
        let mostrar = item.mostrar.toLowerCase() === "si";
        let cumple = item.cumple.toLowerCase() === "cumple";
        let valor = item.valor;

        let icono = <span className="plantilla material-symbols-outlined icon1 requisito1">help_outline</span>
        if (cumple)
            icono = <span className="plantilla material-symbols-outlined icon1 requisito1" style={{ color: "var(--green)" }}>check_circle</span>
        if (!cumple) {
            if (requisito.estado === "error")
                icono = <span className="plantilla material-symbols-outlined icon1 requisito1" style={{ color: "var(--red)" }}>error</span>
            if (requisito.estado === "warning")
                icono = <span className="plantilla material-symbols-outlined icon1 requisito1" style={{ color: "var(--orange)" }}>schedule</span>
        }

        if (!mostrar && !cumple) mostrar = true;
        if (!mostrar) return null;

        return (<>
            <Row>
                <Col md={1} xs={{ span: 1, offset: 0 }} >
                    {icono}
                </Col>
                <Col md={8} xs={8}>
                    <small><strong>{item.etiqueta}</strong></small>
                </Col>
            </Row>
            <Row className="mb-2">
                <Col md={3} xs={{ span: 10, offset: 1 }}>
                    <small>{item.valor}</small>
                </Col>
            </Row>
        </>
        )
    };

    let lista = requisito.lista
    if (!lista) lista = [];

    return (<>
        <Modal show={show} onHide={handleClose} style={{ maxHeight: "100%" }}>
            <Modal.Header closeButton>
                <Modal.Title>{requisito.etiqueta}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <p dangerouslySetInnerHTML={{ __html: requisito.mensaje } }></p>
                </Row>

                {lista.map((item, key) => <ElementoLista item={item} key={key} />)}
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display :"contents"}}> 
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);
};

const ModalHelpOnUpdateButton = ({ show, onClose, planAcademico}) => {
    const handleClose = () => { onClose() };

    return (<>
        <Modal show={show} onHide={handleClose} style={{ maxHeight: "100%" }}>
            <Modal.Body>
                <Row>
                    <Plantilla id="HelpOnUpdateButton" planInfo={planAcademico} />
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Row style={{ display: "contents" }}>
                    <Col className="d-grid gap-2" >
                        <Button variant="primary" onClick={handleClose}>
                            Aceptar
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    </>);
};

/**
 * Renders Requisitos component
 */
export default function Requisitos(props) {
    const [planAcademico, setPlanAcademico] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [showHelpOnUpdateModal, setShowHelpOnUpdateModal] = useState(false);
    const [leftSeconds, setLeftSeconds] = useState(getConfiguration().requisitosRefreshSeconds);

    const { error, clearError, showErrorModal } = useErrorHandling('PA003');
    const handleOnContinuar = () => { props.onSiguiente(); };

    useEffect(() => {
        if (leftSeconds <= 0) return;
        if (leftSeconds > 0) { setTimeout(() => { setLeftSeconds(leftSeconds - 1); }, 1000) }
    }, [leftSeconds])

    const handleOnReload = () => {
        const successCallback = (data) => {
            props.onUpdateStudentInfo(data);
            const getPlanData = (studentInfo, planId) => { return studentInfo.filter((x) => x.planacademico === planId)[0]; };
            const planData = getPlanData(data, planAcademico.planacademico);
            setPlanAcademico(planData);
            setLeftSeconds(getConfiguration().requisitosRefreshSeconds);
            window.scrollTo(0, 0);
        };

        GetStudentInfo(planAcademico.matricula, null, successCallback);
    };

    const executeWithSpinner = (func) => {
        setShowSpinner(true);

        func.then(res => res)
            .catch(err => handleError(err, '001'))
            .finally(() => setShowSpinner(false));
    };

    const handleError = (err, defaultNumber) => {
        const errEx = (err instanceof PortalError) ? { message: err.message, number: err.number } : { number: defaultNumber }
        showErrorModal(errEx.message, error.serie, errEx.number);
    };

    useEffect(() => {
        setPlanAcademico(props.planAcademico);
    }, []);

    if (!planAcademico) return null;

    function GetStudentInfo(matricula, planAcademico, successCallback) {
        setShowSpinner(true);

        createAPIEndpoint(ENDPOINTS.getInformation)
            .fetchById(matricula)
            .then(res => {
                successCallback(res.data);
                return;
            })
            .catch(err => {
                showErrorModal(null, error.serie, '001');
            })
            .finally(() => {
                setShowSpinner(false);
            });
    }

    const handleGetPaymentSSO = (planAcademico) => {
        var func = getPaymentSSO(planAcademico)
            .then((link) => {
                //if (!link) throw new PortalError("002", "Ocurrio un error al establecer la relacion de confianza con el portal de pagos. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema");

                //windowOpen(link);
                if (!link) throw new PortalError("002", "Ocurrio un error al establecer la relacion de confianza con el portal de pagos. Por favor intenta nuevamente.<br /><br />Si el problema persiste contacta al administrador del sistema");

                if (isUserFromApp()) {
                    let encodedLink = btoa(link);
                    window.location.href = withPublicUrl(`/RedirectToPaymentPortal.html?link=${encodedLink}`);
                    return;
                }

                windowOpen(link);
            });

        executeWithSpinner(func);
    };

    let origRequisitos = planAcademico.requisitos;
    if (!origRequisitos) origRequisitos = [];

    let requisitos = origRequisitos.map((req) => {
        return new innerRequisito(req)
    });

    let cumpleTodo = requisitos.every((x) => x.estado !== "error");

    if (getConfiguration().skipRequisitosWhenCompleted) {
        if (cumpleTodo) setTimeout(() => { handleOnContinuar(); }, 100)
    }

    setTimeout(() => {
        setProgress(50, 'Validación de requisitos');
    }, 100)

    return (
        <>
            <div className="container">
                <Spinner show={showSpinner} />

                <ErrorModal error={error} onClose={clearError} />

                <Plantilla id="3_2_requisitos" planInfo={planAcademico} />

                {requisitos.map((item, i) =>
                    <Requisito key={i} requisito={item} onBotonPortalPagosClick={() => handleGetPaymentSSO(planAcademico)} />)}

                {!cumpleTodo && (
                    <Row className="mb-3 mt-4">
                        <Col className="col-sm-12" style={{ display: "flex" }}>
                            <Button variant="link btn-actualizar" disabled={leftSeconds > 0}
                                onClick={handleOnReload} style={{ width: "100%" }}>
                                Actualizar el sistema {leftSeconds ? "(" + leftSeconds + ")" : ""}
                            </Button>

                            <ModalHelpOnUpdateButton show={showHelpOnUpdateModal} onClose={() => { setShowHelpOnUpdateModal(false) }} />

                            <Button variant="link" className="help-button" onClick={() => { setShowHelpOnUpdateModal(true) }}>
                                <span className="material-symbols-outlined icon">help_outline</span>
                            </Button>
                        </Col>
                    </Row >
                )}

                <Row className="mb-3 mt-4">
                    <Col className="d-grid gap-2">
                        <Button variant="primary" disabled={!cumpleTodo} onClick={handleOnContinuar}>Continuar</Button>
                    </Col>
                </Row >

                <ContinuarMasTardeButton />
            </div>

        </>
    );
}


